var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20883 4.53155C6.09349 4.6508 5.9065 4.6508 5.79117 4.53155L1.97868 0.589439C1.86334 0.470187 1.67635 0.470187 1.56102 0.589439L0.586499 1.59709C0.471167 1.71635 0.471167 1.90969 0.586499 2.02895L5.79117 7.41056C5.90651 7.52981 6.09349 7.52981 6.20883 7.41056L11.4135 2.02895C11.5288 1.90969 11.5288 1.71635 11.4135 1.59709L10.439 0.58944C10.3236 0.470187 10.1367 0.470188 10.0213 0.58944L6.20883 4.53155Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ef39fcdf0b51e47bbab30bcad98063f0.svg";
export { ForwardRef as ReactComponent };